import React from 'react';
import { Container } from '@/components';
import { BTSChatProvider } from './BTSChatContext';
import SchoolList from './SchoolList';
import ChatPanel from './ChatPanel';

const OngoingChats = () => {
  return (
    <BTSChatProvider>
      <Container title="BTS Chat">
        <div className="flex flex-col h-[calc(100vh-110px)] bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mt-2 min-w-0">
          <div className="flex flex-1 lg:flex-row flex-col divide-y lg:divide-y-0 lg:divide-x divide-gray-200 h-full min-h-0 min-w-0">
            {/* Left Panel - School and Classes List */}
            <div className="w-full lg:w-[380px] xl:w-[420px] flex flex-col h-full min-h-0 bg-white flex-shrink-0 min-w-0">
              <SchoolList />
            </div>

            {/* Right Panel - Chat Message Thread */}
            <div className="flex-1 flex flex-col h-full min-h-0 min-w-0 bg-white">
              <ChatPanel />
            </div>
          </div>
        </div>
      </Container>
    </BTSChatProvider>
  );
};

export default OngoingChats;
